var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVettingLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85965 1.66781C8.78033 1.64693 7.72588 1.99298 6.86881 2.64933C6.01175 3.30569 5.4028 4.23351 5.14163 5.28096C4.88045 6.32841 4.98252 7.43349 5.4311 8.4154C5.87969 9.39731 6.64823 10.1979 7.61101 10.6862C7.98481 10.8929 8.38611 11.0454 8.80286 11.1391V17.3606C8.82586 17.6261 8.94757 17.8733 9.14396 18.0534C9.34035 18.2335 9.59713 18.3334 9.86361 18.3334C10.1301 18.3334 10.3869 18.2335 10.5833 18.0534C10.7797 17.8733 10.9014 17.6261 10.9244 17.3606V11.1391C11.3411 11.0454 11.7424 10.8929 12.1162 10.6862C13.0797 10.1976 13.8487 9.39636 14.2972 8.41361C14.7457 7.43086 14.8472 6.32491 14.585 5.27696C14.3228 4.229 13.7124 3.30116 12.8539 2.64545C11.9954 1.98975 10.9397 1.64504 9.85965 1.66781ZM9.85965 9.61351C9.23105 9.61351 8.61655 9.42712 8.09389 9.07789C7.57122 8.72866 7.16385 8.23226 6.9233 7.6515C6.68274 7.07075 6.61979 6.4317 6.74243 5.81518C6.86506 5.19865 7.16778 4.63233 7.61227 4.18784C8.05676 3.74335 8.62307 3.44066 9.2396 3.31803C9.85612 3.1954 10.4952 3.25834 11.0759 3.4989C11.6567 3.73946 12.1531 4.14682 12.5023 4.66949C12.8515 5.19215 13.0379 5.80662 13.0379 6.43523C13.0379 7.27816 12.7031 8.08657 12.107 8.68262C11.511 9.27866 10.7026 9.61351 9.85965 9.61351Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVettingLocation);
export default __webpack_public_path__ + "static/media/vetting-location.11d5caf7e65e45760d30442d7909d184.svg";
export { ForwardRef as ReactComponent };